const PAYMENT_REQUEST_SET = 'PAYMENT_REQUEST_SET';
const PAYMENT_REQUEST_REMOVE = 'PAYMENT_REQUEST_REMOVE';

export {
  PAYMENT_REQUEST_SET,
  PAYMENT_REQUEST_REMOVE,
};



// WEBPACK FOOTER //
// ./src/app/actions/payment-request/types.js